export const CANONICAL_REVIEWEE_NAME_TAG = '{{RevieweeName}}';
export const CANONICAL_COMPANY_NAME_TAG = '{{CompanyName}}';

export type MergeTagMap = Record<string, string>;

const wrap = (token: string): string => `{{${token}}}`;

const pair = (reviewee: string, company: string): MergeTagMap => ({
    [CANONICAL_REVIEWEE_NAME_TAG]: wrap(reviewee),
    [CANONICAL_COMPANY_NAME_TAG]: wrap(company),
});

export const MERGE_TAG_MAP: Record<string, MergeTagMap> = {
    en: pair('RevieweeName', 'CompanyName'),
    ar: pair('اسمالمقيم', 'اسمالشركة'),
    bg: pair('ИмеОценяван', 'ИмеКомпания'),
    cs: pair('JménoHodnoceného', 'NázevSpolečnosti'),
    de: pair('NameBeurteilter', 'Firmenname'),
    es: pair('NombreEvaluado', 'NombreEmpresa'),
    et: pair('HinnatavaNimi', 'EttevõtteNimi'),
    fr: pair('NomÉvalué', 'NomEntreprise'),
    fr_FR: pair('NomÉvalué', 'NomEntreprise'),
    he: pair('שםהמוערך', 'שםהחברה'),
    hr: pair('ImeOcjenjivanog', 'NazivTvrtke'),
    hu: pair('ÉrtékeltNeve', 'Cégneve'),
    it: pair('NomeValutato', 'NomeAzienda'),
    ja: pair('評価対象者名', '会社名'),
    km: pair('ឈ្មោះអ្នកវាយតម្លៃ', 'ឈ្មោះក្រុមហ៊ុន'),
    lt: pair('VertinamojoVardas', 'ĮmonėsPavadinimas'),
    lv: pair('VērtējamāVārds', 'UzņēmumaNosaukums'),
    nl: pair('NaamBeoordeelde', 'Bedrijfsnaam'),
    pl: pair('ImięOcenianego', 'NazwaFirmy'),
    pt: pair('NomeAvaliado', 'NomeEmpresa'),
    pt_BR: pair('NomeAvaliado', 'NomeEmpresa'),
    ro: pair('NumeEvaluat', 'NumeCompanie'),
    sk: pair('MenoHodnoteného', 'NázovSpoločnosti'),
    sl: pair('ImeOcenjevanca', 'ImePodjetja'),
    sr: pair('ИмеОцењиваног', 'НазивКомпаније'),
    sw: pair('JinaLaAliyePimwa', 'JinaLaKampuni'),
    th: pair('ชื่อผู้ถูกประเมิน', 'ชื่อบริษัท'),
    tl: pair('PangalanNgSinusuri', 'PangalanNgKumpanya'),
    tr: pair('DeğerlendirilenAdı', 'ŞirketAdı'),
    vi: pair('TênNgườiĐượcĐánhGiá', 'TênCôngTy'),
    zh: pair('被评价者姓名', '公司名称'),
    zh_Hant: pair('被評價者姓名', '公司名稱'),
};

export const ENGLISH_MERGE_TAG_MAP: MergeTagMap = MERGE_TAG_MAP.en as MergeTagMap;
